import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TestProvider } from '../providers/test-provider';
import { LangsProvider } from "../../common/providers/langs-provider";
import { Test } from "../../common/models/test";

@Injectable({providedIn: 'root'})
export class TestResolver implements Resolve<Test> {
    constructor(
        private langsProvider: LangsProvider,
        private testProvider: TestProvider,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return this.testProvider.get(
            +route.params['testId'],
            {lang: this.langsProvider.getBestLangId()}
        );
    }
}
